import React from "react";

const payoffMessage = () => {
  return (
    <div className="row-no-gutters mb-3">
      <div className="col-12 p-0">
        <div className="payoff-msg primary">
          This payment will result in the <u>payoff of this loan.</u>
        </div>
      </div>
    </div>
  );
};

export default payoffMessage;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/payoff-message.component.js